<template>
    <div class="focus-chart">
        <div
            :id="`chartHook_${props.chartType}_${entityStore.strategyTabNodeFilter}`"
            class="w-100"
        ></div>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, onBeforeUnmount, computed, watch, nextTick } from 'vue'
import { useEntityStore } from '@/stores'
import { focusChart } from '@/composables/focusChart.js'
import { debounce } from 'lodash-es'

const entityStore = useEntityStore()
const isUpdating = ref(false)

const props = defineProps({
    chartType: {
        type: String,
        default: 'treemap',
    },
    chartData: {
        type: Array,
        default: () => [],
    },
    chartOverwriteData: {
        type: Array,
        default: () => [],
    },
    toggleValue: {
        type: String,
        default: 'coverage',
    },
    chartSortOverride: {
        type: Array,
        default: () => [],
    },
})

const debouncedUpdate = debounce(async () => {
    if (isUpdating.value) return
    isUpdating.value = true
    try {
        await nextTick()
        await mapDataForChart(targetDataSource.value, true)
    } catch (error) {
        console.error('Error updating chart:', error)
    } finally {
        isUpdating.value = false
    }
}, 300)

// Watch for changes in chartData
watch(
    () => props.chartData,
    () => {
        resetChart()
    },
    { deep: true }
)

// Watch for changes in chartOverwriteData
watch(
    () => props.chartOverwriteData,
    () => {
        resetChart()
    },
    { deep: true }
)

const targetDataSource = computed(() => {
    return props.chartOverwriteData.length > 0 ? props.chartOverwriteData : props.chartData
})

const { mappedData, mapDataForChart, resetChart } = focusChart(props)

onBeforeUnmount(() => {
    debouncedUpdate.cancel()
})
</script>

<style lang="scss" scoped>
.focus-chart {
    [id^='chartHook_'] {
        // id that starts with chartHook_
        width: 100%;
        min-height: 400px;

        div {
            height: 100%;
        }
    }
}
</style>
